module.exports = __webpack_public_path__ + "img/down.53ba4e8.png";